import React from 'react';
import { withPortlet } from 'js/components/system/Portlet';
import { componentService } from 'js/services/component.service';
import { map, partition, pipe, prop, propEq, unnest } from 'ramda';

import { getComppointsBonusTemplate, getComppointsConversion, getComppointsDetails } from './actions';
import reducer from './reducer';
import parse from './parse';
import Header from './Header';
import Description from './Description';
import Cards from './Cards';
import { COMPPOINTS } from './constants';
import { useParams } from './hooks';

import style from './index.scss';

export const getBonusTemplate = async (bonusCodes, isGameContext) => {
    const { data: { bonusTemplates = [] } } = await getComppointsBonusTemplate(bonusCodes, isGameContext);

    return bonusTemplates;
};

export const getBonusTemplates = async (bonusConversionDetails = []) => {
    // COR18-3523 split requests by bonus type 'After Wager'
    const bonusTemplates = await Promise.all(
        pipe(
            partition(propEq('bonusPlayType', 'after-wager')),
            map((details, index) => getBonusTemplate(details.map(prop('bonusTemplateCode')), !index))
        )(bonusConversionDetails)
    );

    return unnest(bonusTemplates);
};

export const fetchComppoints = async (config) => {
    const balanceTypes = Object.keys(config).filter((item) => config[item]);
    const [{ data: { balances = [] } }, { data: conversion }] = await Promise.all([
        getComppointsDetails(balanceTypes),
        getComppointsConversion()
    ]);

    const bonusTemplates = await getBonusTemplates(conversion.bonusConversionDetails);

    return {
        balances,
        conversion,
        bonusTemplates
    };
};

export const ComppointsBare = () => (
    <div className={style.container}>
        <Header />
        <Description />
        <Cards />
    </div>
);

export const Comppoints = withPortlet({
    forLoggedIn: true,
    useParams,
    fetch: fetchComppoints,
    onResponse: parse,
    reducer
})(ComppointsBare);

componentService.registerPageComponents({ [COMPPOINTS]: Comppoints });
